import React from 'react';
import buttonClose from "../../../assets/images/shared/modals/button-close.svg";
import check from "../../../assets/images/shared/modals/check-data.svg";

const AddData = ({ showModalAddData, closeModalAddData }) => {
  if (!showModalAddData) return null; // No renderiza si el modal no está activo

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="w-[276px] h-[232px] p-2 bg-white rounded-3xl shadow-lg flex flex-col  ">
        <div className='flex justify-end'>
          <button
            onClick={closeModalAddData}
            className="rounded-md"
          >
            <img src={buttonClose} alt="Cerrar" />
          </button>
        </div>
        <div className='flex flex-col items-center justify-center'>
          <img src={check} alt="registrado" className="w-[126px] h-[125px]" />
          <p className="mb-2 text-[12px] font-itcdemi text-gray">
            ¡Los datos se guardaron correctamente!
          </p>
        </div>
          
        </div>
      </div>
  );
};
export default AddData;
